<template>
  <v-container class="col-12">
    <v-card>
      <v-row class="mx-2 mb-4" style="white-space: nowrap">
        <select-project
          v-model="project"
          :multiple="true"
          class="report-base-filter"
          style="min-width: 200px; flex: auto; width: auto; max-width: 350px;"
        >
        </select-project>
        <!--        <v-select-->
        <!--          v-model="project"-->
        <!--          :items="projectList"-->
        <!--          label="Project"-->
        <!--          hide-details-->
        <!--          multiple-->
        <!--          class="report-base-filter"-->
        <!--          style="min-width: 200px; flex: auto; width: auto; max-width: 350px;"-->
        <!--        >-->
        <!--          <template v-slot:selection="{ item: chipItem, index }">-->
        <!--            <div style="max-width: 180px" class="v-select__selection v-select__selection&#45;&#45;comma" v-if="index < chipCount">{{ chipItem.text || chipItem }}{{ index < project.length - 1 ? ',' : '' }} &nbsp;</div>-->
        <!--            <span-->
        <!--              class="caption float-right"-->
        <!--              v-if="index === chipCount && (project || []).length > chipCount"-->
        <!--            >(+{{ (project || []).length - chipCount }} others)</span>-->
        <!--          </template>-->
        <!--        </v-select>-->

        <v-select
          :items="dateRangeList"
          :value="dateRangeList[0]"
          label="Period"
          v-on:change="changeTimePeriod"
          hide-details
          class="report-base-filter"
          style="min-width: 150px"
        ></v-select>
        <date-picker
          v-model="from"
          label="Date From"
          style="max-width: 140px;"
        />

        <date-picker
          v-model="to"
          label="Date To"
          style="max-width: 140px;"
        />

        <v-btn color="info" v-on:click="search" class="mt-3" :disabled="loading" :loading="loading">Search</v-btn>
        <export :fields="exportFields" without_sg="true" :data="items" :reportName="title" :project="project" />
        <v-spacer />

        <v-badge
          bordered
          bottom
          right
          class=""
          color="error"
          :content="selected.length"
          :value="selected.length"
          overlap
        >
          <v-row class="py-2" :class="updateButtonRowClasses">
            <v-btn
              v-if="$store.state.auth.checkAccess({key: 'clean_affiliate', value: true})"
              color="error"
              width="117"
              :loading="loading"
              :disabled="loading"
              v-text="'Unsubscribe'"
              @click="update('clear', selected)"
            />

            <v-btn
              value="1"
              v-if="$store.state.auth.checkAccess({key: 'clean_affiliate', value: true})"
              color="warning"
              :loading="loading"
              :disabled="loading"
              width="117"
              v-text="'ignore once'"
              @click="update('once', selected)"
            />
          </v-row>
        </v-badge>
      </v-row>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="filteredItems"
        :loading="loading"
        selectable-key="account_id"
        v-model="selected"
        show-select
        :items-per-page="-1"
        item-key="account_id"
        hide-default-footer
        class="col-12 pa-0 affiliate_stats-dt affiliate-export"
        fixed-header
      >

        <template v-slot:item.row_num="{ item }">
          <span class="row_num"></span>
        </template>
        <template v-slot:item.funded="{ item }">
          {{ item.funded ? 'Yes' : 'No' }}
        </template>

        <template v-slot:item.login="{ item, header }">
          <a :href="'/user-management/' + (item.prefix || '') + (item.login.replace(new RegExp('^' + (item.prefix || '')), ''))" target="_blank">{{ item.login }}</a>
        </template>
        <template v-slot:item.account_id="{ item, header }">
          <a :href="'/user-management/' + (item.prefix || '') + (item.login.replace(new RegExp('^' + (item.prefix || '')), ''))" target="_blank">{{ item.account_id }}</a>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            v-if="$store.state.auth.checkAccess({key: 'clean_affiliate', value: true})"
            width="95"
            color="error"
            :loading="loading"
            :disabled="loading"
            x-small
            v-text="'Unsubscribe'"
            @click="update('clear', [item])"
          />

          <v-btn-toggle v-model="item.pp_ignore ? '1' : '0'">
            <v-btn
              value="1"
              v-if="$store.state.auth.checkAccess({key: 'clean_affiliate', value: true})"
              width="95"
              color="warning"
              :loading="loading"
              :disabled="loading"
              x-small
              v-text="'ignore once'"
              @click="update('once', [item])"
            />
          </v-btn-toggle>
        </template>

        <template v-slot:body.prepend>
          <tr class="grey lighten-3 affiliate-export_filters">
            <td style="border: none"></td>
            <td
              v-for="header in headers"
              :key="header.text"
              style="border: none"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                single-line
                class="data-table-finance-filter-select"
                :items="filters[header.value].values || columnValueList(header.value)"
                v-model="filters[header.value].data"
              />
              <v-combobox
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'combobox'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                single-line
                class="data-table-finance-filter-select"
                :items="filters[header.value].values || columnValueList(header.value)"
                v-model="filters[header.value].data"
              />
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                hide-details
              />
            </td>
          </tr>
        </template>


      </v-data-table>
    </v-card>
  </v-container>
</template>

<style>

  .affiliate-export tr:not(.affiliate-export_filters) {
    counter-increment: row-num;
  }

  .affiliate-export tr td:first-child .row_num::before {
    content: counter(row-num) ". ";
  }

  .data-table-finance-filter-select .v-select__selections {
    height: 32px;
    overflow: hidden;
    white-space: nowrap;
  }

  .data-table-finance-filter-select {
    max-width: 150px;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  .data-table-finance-filter-textfield input {
    /*text-align: center;*/
  }

  .data-table-finance-filter-textfield {
    max-width: 80px;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }
</style>

<style lang="scss" scoped>
  .gap-6 {
    gap: 1rem;
  }

  .limited-width {
    max-width: 130px;
  }
</style>

<script>
  import { API } from '@/utils/api'
  import { map, get, filter, toString, debounce } from 'lodash'
  import moment from 'moment'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    props: { title: {}, defaultParams: { default: () => ({}) } },
    components: {
      SelectProject,
      DatePicker,
      Export: () => import('@/components/helper/Export')
    },
    data: () => ({
      dateRangeList,

      filtersD: {},

      chipCount: 3,
      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),

      loading: false,
      headers: [
        { text: '#', value: 'row_num', sortable: false, fixed: true },
        { text: '', value: 'action' },
        { text: 'AccountID', value: 'account_id' },
        { text: 'Login', value: 'login' },
        { text: 'Created', value: 'created', width: '150px' },
        { text: 'Aff', value: 'affiliate' },
        { text: 'Currency', value: 'currency' },
        { text: 'Country', value: 'country' },
        { text: 'Funded', value: 'funded', sortable: true },
        { text: 'Deposit', value: 'deposit_eur', sortable: true },
        { text: 'Withdraw', value: 'withdraw', sortable: true },
        { text: 'Correction', value: 'correction', sortable: true },
        { text: 'Cash Bonus', value: 'cash_bonus', sortable: true },
        { text: 'Bonus', value: 'bonus', sortable: true },
        { text: 'Bet', value: 'bet', sortable: true },
        { text: 'Win', value: 'win', sortable: true },
        { text: 'FS Win', value: 'freespin_win', sortable: true },
        { text: 'GGR', value: 'ggr', sortable: true },
        { text: 'NGR', value: 'ngr', sortable: true },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Type', value: 'type', sortable: true },
      ],
      filters: {
        type: { data: [], type: 'select' },
        affiliate: { data: [], type: 'select' },
        funded: { data: [], type: 'select', values: [ { text: 'Yes', value: true }, { text: 'No', value: false } ] },
        currency: { data: [], type: 'select', width: '75px' },
        login: { data: [], type: 'text' },
        email: { data: [], type: 'text' },
        country: { data: [], type: 'select', width: '75px' },
        status: { data: [], type: 'select', width: '100px' },
        account_id: { data: [], type: 'text' },
        deposit: { data: [], type: 'text' },
        withdraw: { data: [], type: 'text' },
        bonus_deposit: { data: [], type: 'text' },
        bet: { data: [], type: 'text' },
        win: { data: [], type: 'text' },
        ngr: { data: [], type: 'text' },
        ggr: { data: [], type: 'text' },
      },
      project: [],
      items: [],
      selected: [],
    }),

    computed: {
      innerWidth: function () {
        return window.innerWidth
      },
      updateButtonRowClasses () {
        return this.$vuetify.breakpoint.sm
          ? [ 'flex-nowrap', 'ma-0', 'gap-6' ]
          : [ 'col-1', 'mr-0', 'limited-width' ]
      },
      // projectList: function () {
      //   return map(this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id }))
      // },
      exportFields: function () {
        return map(this.headers, 'value')
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filtersD).every(f => {
            try {
              if (this.filtersD[f].data.length > 1 && typeof this.filtersD[f].data == 'string' && this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filtersD[f].data
                if (this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filtersD[f].data
                return eval((get(d, f) || '0').toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filtersD[f].data.length < 1
              || ((this.filtersD[f].data.includes((get(d, f) || '')) && toString((get(d, f) || '')).length > 0)
                || (this.filtersD[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
                || (this.filtersD[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
                || (typeof get(d, f) != 'boolean' && ((get(d, f) || '').toString().toLowerCase()).indexOf(this.filtersD[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    mounted () {
      // this.project = [ this.projectList[0].value ]
    },

    watch: {

      filters: {
        handler: debounce(function () {
          this.filtersD = this.filters
        }, 800),
        deep: true,
      },
    },

    methods: {
      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.to
      },

      search () {
        this.loading = true
        this.selected = []
        return API.call('/$v/reports/affiliate_daily_export.json', {
          from: this.from,
          to: this.to,
          by_entities: this.project
        }, null, this.project[0]).then(resp => {
          this.items = resp.data
          return resp.data
        }).finally(() => {
          this.loading = false
        })
      },

      // async update (type, login, account_id) {
      //
      //   let fields = {}
      //   let message = 'Confirm unsubscribe'
      //   if (type == 'clear') {
      //     fields.affiliate = ''
      //     message = 'Unsubscribe player from affiliate'
      //   } else if (type == 'once') {
      //     fields.pp_ignore = true
      //     message = 'Don\'t send data by this customer next day'
      //   }
      //
      //   if (!await this.$root.$confirm('Confirm', message)) {
      //     return
      //   }
      //
      //   return API.call('/$v/account/update.json', {
      //     login: login,
      //     account_id: account_id,
      //     fields,
      //   }, { login }).then(resp => {
      //     return resp.data
      //   }).then(r => {
      //     this.$notification.show = true
      //     this.$notification.message = 'Account updated'
      //     this.$notification.type = 'success'
      //   }).catch(e => {
      //   })
      // },

      async update (type, account_ids) {

        if (account_ids.length == 0) return

        let fields = {}
        let message = 'Confirm unsubscribe'
        if (type == 'clear') {
          fields.affiliate = ''
          message = 'Unsubscribe player from affiliate'
        } else if (type == 'once') {
          fields.pp_ignore = true
          message = 'Don\'t send data by this customer next day'
        }

        if (!await this.$root.$confirm('Confirm', message)) {
          console.log('ignore')
          return
        }

        this.loading = true
        return API.call('/$v/affiliate/update.json', {
          account_ids: map(account_ids, 'account_id'),
          by_entities: this.project,
          fields,
        }, null, this.project[0]).then(resp => {
          return resp.data
        }).then(r => {
          this.$notification.show = true
          this.$notification.message = 'Account updated'
          this.$notification.type = 'success'
          return this.search()
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },

      columnValueList (val) {
        return filter(this.items.map(d => d[val]), (i) => i)
      },
    },
  }
</script>
